import React from 'react';
import type ProjectSettingsServiceDeskInternalNotificationsType from '@atlassian/jira-spa-apps-project-settings-service-desk-internal-notifications/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskInternalNotifications = lazyForPaint<
	typeof ProjectSettingsServiceDeskInternalNotificationsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-internal-notifications", jiraSpaEntry: "async-project-settings-service-desk-internal-notifications" */ '@atlassian/jira-spa-apps-project-settings-service-desk-internal-notifications'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskInternalNotifications}
		pageId="project-settings-internal-notifications"
		shouldShowSpinner
	/>
);
